import { render, staticRenderFns } from "./GamePlayers.vue?vue&type=template&id=680401fc&"
import script from "./GamePlayers.vue?vue&type=script&lang=js&"
export * from "./GamePlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports